import { render, staticRenderFns } from "./dashKras.vue?vue&type=template&id=e178c4c8"
import script from "./dashKras.vue?vue&type=script&lang=js"
export * from "./dashKras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e178c4c8')) {
      api.createRecord('e178c4c8', component.options)
    } else {
      api.reload('e178c4c8', component.options)
    }
    module.hot.accept("./dashKras.vue?vue&type=template&id=e178c4c8", function () {
      api.rerender('e178c4c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dashboard/processRam/dashKras.vue"
export default component.exports